module.exports = __webpack_public_path__ + "static/goal-53db8f0495fad6040d431719bc644a8b.jpeg";